/** Default scroll targets for App PDP sections when Uniform omits sectionId. */
export const APP_PDP_SECTION_IDS = {
  stateOfMind: 'state-of-mind',
  sound: 'sound',
  features: 'features',
  plans: 'plans',
} as const;

/**
 * App PDP header summary nav + link CTA as configured on the page composition
 * (`headerSummary` / `headerSummaryCta` slots in uniform-data). Used when the
 * Canvas delivery response omits those slots or parameters.
 */
export const APP_PDP_HEADER_SUMMARY_NAV = [
  {
    sectionId: APP_PDP_SECTION_IDS.stateOfMind,
    labelKey: 'web_appPdp_headerSummaryNavigation_stateOfMind',
  },
  {
    sectionId: APP_PDP_SECTION_IDS.sound,
    labelKey: 'web_appPdp_headerSummaryNavigation_sound',
  },
  {
    sectionId: APP_PDP_SECTION_IDS.features,
    labelKey: 'web_appPdp_headerSummaryNavigation_features',
  },
  {
    sectionId: APP_PDP_SECTION_IDS.plans,
    labelKey: 'web_appPdp_headerSummaryNavigation_plans',
  },
] as const;

export const APP_PDP_HEADER_SUMMARY_LINK_CTA = {
  labelKey: 'web_appPdp_hero_buttonText',
  href: '/plans',
} as const;
